import {
    BotConvoStartedAction,
    ContactInfoGatheredAction,
    LocalSettingsLoadedAction,
    LocationSettingsFetchedAction,
    RealConvoStartedAction,
} from '../typedefs/actions';
import * as actionTypes from '../typedefs/actionTypes';
import { VisitorState } from '../typedefs/store';
import { createReducer } from './util';

const initialState: VisitorState = {
    contactInfo: {},
} as VisitorState;

const handlers = {
    [actionTypes.BOT_CONVO_STARTED]: botConvoStarted,
    [actionTypes.LOCAL_SETTINGS_LOADED]: localSettingsLoaded,
    [actionTypes.SOCKET_EVENT_CONTACT_INFO_GATHERED]: contactInfoGathered,
    [actionTypes.CONTACT_INFO_INJECTED]: contactInfoGathered,
    [actionTypes.LOCATION_SETTINGS_FETCHED]: locationSettingsFetched,
};

function botConvoStarted(state: VisitorState, action: BotConvoStartedAction) {
    return {
        ...state,
        hasConvo: true,
        visitorId: action.payload.visitorId,
        visitorToken: action.payload.token,
    };
}

function localSettingsLoaded(state: VisitorState, action: LocalSettingsLoadedAction): VisitorState {
    const { hideBanner, ...toInclude } = action.payload;
    return { ...state, ...toInclude };
}

/**
 * Any time Watson gathers info, an event will be sent by the API with that data. It may be partial
 * data, and we don't want it to overwrite anything we already know 
 */
function contactInfoGathered(state: VisitorState, action: ContactInfoGatheredAction): VisitorState {
    return {
        ...state,
        contactInfo: {
            ...state.contactInfo,
            firstName: action.payload.firstName || state.contactInfo.firstName,
            lastName: action.payload.lastName || state.contactInfo.lastName,
            email: action.payload.email || state.contactInfo.email,
            phone: action.payload.phone || state.contactInfo.phone,
        },
    };
}

/**
 * If the site has provided visitor information via inline config and we don't already have visitor info, store it
 */
function locationSettingsFetched(
    state: VisitorState,
    action: LocationSettingsFetchedAction,
): VisitorState {
    const { inlineConfig } = action.payload;
    if (!inlineConfig.visitor) return state;

    const existingInfo = state.contactInfo;
    const newInfo = inlineConfig.visitor;

    return {
        ...state,
        contactInfo: {
            ...state.contactInfo,
            firstName: existingInfo.firstName || newInfo.firstName || undefined,
            lastName: existingInfo.lastName || newInfo.lastName || undefined,
            email: existingInfo.email || newInfo.email || undefined,
            phone: existingInfo.phone || newInfo.phone || undefined,
        },
    };
}

export default createReducer(initialState, handlers);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/reducers/visitor.ts